import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { of } from 'rxjs';

import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAdministrationList(body: any) {
    const link = this.apiUrl + ApiUrls.getAdministrationList;
    return this.http.post<any>(link, body);
  }

  createAdministration(body: any) {
    const link = this.apiUrl + ApiUrls.createAdministration;
    return this.http.post<any>(link, body);
  }

  getAdministrationById(id: number) {
    const link = this.apiUrl + ApiUrls.getAdministrationById + "/" + id;
    return this.http.get<any>(link);
  }

  updateAdministration(body: any) {
    const link = this.apiUrl + ApiUrls.updateAdministration;
    return this.http.post<any>(link, body);
  }

  deleteAdministration(id: number) {
    const link = this.apiUrl + ApiUrls.deleteAdministration + "/" + id;
    return this.http.post<any>(link, id);
  }


}
